// Build-time gated. The RBT facilitation panel is meaningless in cierge
// builds; we render nothing so Terser DCEs the RBT-labelled JSX.
const isCiergeBuild = process.env.REACT_APP_BRAND_MODE === "cierge";

function RbtFacilitationContent({ prompts = [] }) {
    return (
        <section
            className="surface-subtle rounded-sm border-l-4 border-slate-900 p-6 lg:p-8"
            data-testid="rbt-facilitation"
        >
            <div className="overline mb-3 text-slate-700">RBT Facilitation</div>
            <h3 className="text-xl lg:text-2xl font-bold tracking-tight mb-5">
                Questions for the room
            </h3>
            <ol className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-sm text-slate-800 list-decimal pl-5">
                {prompts.map((p) => (
                    <li key={p} className="leading-relaxed">
                        {p}
                    </li>
                ))}
            </ol>
        </section>
    );
}

const RbtFacilitation = isCiergeBuild
    ? function RbtFacilitationStub() { return null; }
    : RbtFacilitationContent;

export default RbtFacilitation;
